import { useState } from 'react';

// TODO solve import from different feature
import { CreateEventFeedback } from 'features/events';

import { Loading } from 'ui';
import { useEventQuery } from '../../queries';

export type EventFeedbackProperties = { feedback: true; eventId: string; onFinish: () => void };
export type NoEventFeedbackProperties = { feedback: false };
export type EventFeedbackOptions = EventFeedbackProperties | NoEventFeedbackProperties;

type P = EventFeedbackProperties;

const EventFeedback = ({ eventId, onFinish }: P) => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(true);
  const { isLoading, data } = useEventQuery({ eventId });

  const closeFeedback = () => {
    setIsFeedbackOpen(false);
    onFinish();
  };

  return (
    <>
      {isLoading || !data ? (
        <Loading />
      ) : (
        !data.feedbacked && (
          <CreateEventFeedback
            isOpened={isFeedbackOpen}
            eventId={eventId}
            onSuccess={closeFeedback}
            onCancel={closeFeedback}
          />
        )
      )}
    </>
  );
};

export default EventFeedback;
